import { Observable } from 'rxjs';

import { SaveUserMoodCmd } from 'user/command/mood/save-user-mood.cmd';
import { UserMoodOutput } from 'user/model/user-mood.output';
import { IUserMood } from 'user/mood/user-mood';

export abstract class UserMoodApplicationPort {
	public abstract mustAskMood(): Observable<boolean>;

	public abstract markMoodAsked(): Observable<void>;

	public abstract fetchLastMood(): Observable<string | Error>;

	public abstract observeLatestUserMood(): Observable<IUserMood>;

	public abstract saveUserMood(cmd: SaveUserMoodCmd): Observable<string | Error>;

	public abstract persistUserMoods(userMoods: UserMoodOutput[]): void;

	public abstract observeMoodsByIds(ids: string[]): Observable<IUserMood[]>;

	public abstract fetchOwnedMoods(): Observable<string[] | Error>;
}
